import {
  Currency,
  parseCurrency,
  type SupportedPaymentCurrency,
  currencyToPaymentCurrency as domainCurrencyToPaymentCurrency,
} from 'domains-billing-currency';
import { Currency as GraphQLCurrency } from 'graphql-query-contracts';

// Mapping from domain Currency to GraphQL Currency enum keys
const DOMAIN_TO_GRAPHQL: Record<Currency, GraphQLCurrency> = {
  [Currency.USD]: GraphQLCurrency.CurrencyUsd,
  [Currency.CAD]: GraphQLCurrency.CurrencyCad,
  [Currency.AUD]: GraphQLCurrency.CurrencyAud,
  [Currency.EUR]: GraphQLCurrency.CurrencyEur,
  [Currency.GBP]: GraphQLCurrency.CurrencyGbp,
  [Currency.HKD]: GraphQLCurrency.CurrencyHkd,
  [Currency.HUF]: GraphQLCurrency.CurrencyHuf,
  [Currency.BRL]: GraphQLCurrency.CurrencyBrl,
  [Currency.SGD]: GraphQLCurrency.CurrencySgd,
  [Currency.INR]: GraphQLCurrency.CurrencyInr,
  [Currency.THB]: GraphQLCurrency.CurrencyThb,
  [Currency.AED]: GraphQLCurrency.CurrencyAed,
  [Currency.ALL]: GraphQLCurrency.CurrencyAll,
  [Currency.AMD]: GraphQLCurrency.CurrencyAmd,
  [Currency.ANG]: GraphQLCurrency.CurrencyAng,
  [Currency.AWG]: GraphQLCurrency.CurrencyAwg,
  [Currency.AZN]: GraphQLCurrency.CurrencyAzn,
  [Currency.BAM]: GraphQLCurrency.CurrencyBam,
  [Currency.BBD]: GraphQLCurrency.CurrencyBbd,
  [Currency.BDT]: GraphQLCurrency.CurrencyBdt,
  [Currency.BGN]: GraphQLCurrency.CurrencyBgn,
  [Currency.BIF]: GraphQLCurrency.CurrencyBif,
  [Currency.BMD]: GraphQLCurrency.CurrencyBmd,
  [Currency.BND]: GraphQLCurrency.CurrencyBnd,
  [Currency.BSD]: GraphQLCurrency.CurrencyBsd,
  [Currency.BWP]: GraphQLCurrency.CurrencyBwp,
  [Currency.BYN]: GraphQLCurrency.CurrencyByn,
  [Currency.BZD]: GraphQLCurrency.CurrencyBzd,
  [Currency.CDF]: GraphQLCurrency.CurrencyCdf,
  [Currency.CHF]: GraphQLCurrency.CurrencyChf,
  [Currency.CNY]: GraphQLCurrency.CurrencyCny,
  [Currency.CZK]: GraphQLCurrency.CurrencyCzk,
  [Currency.DKK]: GraphQLCurrency.CurrencyDkk,
  [Currency.DOP]: GraphQLCurrency.CurrencyDop,
  [Currency.DZD]: GraphQLCurrency.CurrencyDzd,
  [Currency.EGP]: GraphQLCurrency.CurrencyEgp,
  [Currency.ETB]: GraphQLCurrency.CurrencyEtb,
  [Currency.FJD]: GraphQLCurrency.CurrencyFjd,
  [Currency.GEL]: GraphQLCurrency.CurrencyGel,
  [Currency.GIP]: GraphQLCurrency.CurrencyGip,
  [Currency.GMD]: GraphQLCurrency.CurrencyGmd,
  [Currency.GYD]: GraphQLCurrency.CurrencyGyd,
  [Currency.HTG]: GraphQLCurrency.CurrencyHtg,
  [Currency.IDR]: GraphQLCurrency.CurrencyIdr,
  [Currency.ILS]: GraphQLCurrency.CurrencyIls,
  [Currency.ISK]: GraphQLCurrency.CurrencyIsk,
  [Currency.JMD]: GraphQLCurrency.CurrencyJmd,
  [Currency.JPY]: GraphQLCurrency.CurrencyJpy,
  [Currency.KES]: GraphQLCurrency.CurrencyKes,
  [Currency.KGS]: GraphQLCurrency.CurrencyKgs,
  [Currency.KHR]: GraphQLCurrency.CurrencyKhr,
  [Currency.KMF]: GraphQLCurrency.CurrencyKmf,
  [Currency.KRW]: GraphQLCurrency.CurrencyKrw,
  [Currency.KYD]: GraphQLCurrency.CurrencyKyd,
  [Currency.KZT]: GraphQLCurrency.CurrencyKzt,
  [Currency.LBP]: GraphQLCurrency.CurrencyLbp,
  [Currency.LKR]: GraphQLCurrency.CurrencyLkr,
  [Currency.LRD]: GraphQLCurrency.CurrencyLrd,
  [Currency.LSL]: GraphQLCurrency.CurrencyLsl,
  [Currency.MAD]: GraphQLCurrency.CurrencyMad,
  [Currency.MDL]: GraphQLCurrency.CurrencyMdl,
  [Currency.MGA]: GraphQLCurrency.CurrencyMga,
  [Currency.MKD]: GraphQLCurrency.CurrencyMkd,
  [Currency.MMK]: GraphQLCurrency.CurrencyMmk,
  [Currency.MNT]: GraphQLCurrency.CurrencyMnt,
  [Currency.MOP]: GraphQLCurrency.CurrencyMop,
  [Currency.MVR]: GraphQLCurrency.CurrencyMvr,
  [Currency.MWK]: GraphQLCurrency.CurrencyMwk,
  [Currency.MXN]: GraphQLCurrency.CurrencyMxn,
  [Currency.MYR]: GraphQLCurrency.CurrencyMyr,
  [Currency.MZN]: GraphQLCurrency.CurrencyMzn,
  [Currency.NAD]: GraphQLCurrency.CurrencyNad,
  [Currency.NGN]: GraphQLCurrency.CurrencyNgn,
  [Currency.NOK]: GraphQLCurrency.CurrencyNok,
  [Currency.NPR]: GraphQLCurrency.CurrencyNpr,
  [Currency.NZD]: GraphQLCurrency.CurrencyNzd,
  [Currency.PGK]: GraphQLCurrency.CurrencyPgk,
  [Currency.PHP]: GraphQLCurrency.CurrencyPhp,
  [Currency.PKR]: GraphQLCurrency.CurrencyPkr,
  [Currency.PLN]: GraphQLCurrency.CurrencyPln,
  [Currency.QAR]: GraphQLCurrency.CurrencyQar,
  [Currency.RON]: GraphQLCurrency.CurrencyRon,
  [Currency.RSD]: GraphQLCurrency.CurrencyRsd,
  [Currency.RUB]: GraphQLCurrency.CurrencyRub,
  [Currency.RWF]: GraphQLCurrency.CurrencyRwf,
  [Currency.SAR]: GraphQLCurrency.CurrencySar,
  [Currency.SBD]: GraphQLCurrency.CurrencySbd,
  [Currency.SCR]: GraphQLCurrency.CurrencyScr,
  [Currency.SEK]: GraphQLCurrency.CurrencySek,
  [Currency.SLE]: GraphQLCurrency.CurrencySle,
  [Currency.SOS]: GraphQLCurrency.CurrencySos,
  [Currency.SZL]: GraphQLCurrency.CurrencySzl,
  [Currency.TJS]: GraphQLCurrency.CurrencyTjs,
  [Currency.TOP]: GraphQLCurrency.CurrencyTop,
  [Currency.TRY]: GraphQLCurrency.CurrencyTry,
  [Currency.TTD]: GraphQLCurrency.CurrencyTtd,
  [Currency.TWD]: GraphQLCurrency.CurrencyTwd,
  [Currency.TZS]: GraphQLCurrency.CurrencyTzs,
  [Currency.UAH]: GraphQLCurrency.CurrencyUah,
  [Currency.UGX]: GraphQLCurrency.CurrencyUgx,
  [Currency.UZS]: GraphQLCurrency.CurrencyUzs,
  [Currency.VND]: GraphQLCurrency.CurrencyVnd,
  [Currency.VUV]: GraphQLCurrency.CurrencyVuv,
  [Currency.WST]: GraphQLCurrency.CurrencyWst,
  [Currency.XAF]: GraphQLCurrency.CurrencyXaf,
  [Currency.XCD]: GraphQLCurrency.CurrencyXcd,
  [Currency.XCG]: GraphQLCurrency.CurrencyXcg,
  [Currency.YER]: GraphQLCurrency.CurrencyYer,
  [Currency.ZAR]: GraphQLCurrency.CurrencyZar,
  [Currency.ZMW]: GraphQLCurrency.CurrencyZmw,
  [Currency.UNKNOWN]: GraphQLCurrency.CurrencyUnknown,
  // EssensysCredits is deprecated and not supported in GraphQL, map to USD
  [Currency.EssensysCredits]: GraphQLCurrency.CurrencyUsd,
};

// Mapping from GraphQL Currency enum to domain Currency
const GRAPHQL_TO_DOMAIN: Record<GraphQLCurrency, Currency> = {
  [GraphQLCurrency.CurrencyUnknown]: Currency.UNKNOWN,
  [GraphQLCurrency.CurrencyUsd]: Currency.USD,
  [GraphQLCurrency.CurrencyCad]: Currency.CAD,
  [GraphQLCurrency.CurrencyAud]: Currency.AUD,
  [GraphQLCurrency.CurrencyEur]: Currency.EUR,
  [GraphQLCurrency.CurrencyGbp]: Currency.GBP,
  [GraphQLCurrency.CurrencyHkd]: Currency.HKD,
  [GraphQLCurrency.CurrencyHuf]: Currency.HUF,
  [GraphQLCurrency.CurrencyBrl]: Currency.BRL,
  [GraphQLCurrency.CurrencySgd]: Currency.SGD,
  [GraphQLCurrency.CurrencyInr]: Currency.INR,
  [GraphQLCurrency.CurrencyThb]: Currency.THB,
  [GraphQLCurrency.CurrencyAed]: Currency.AED,
  [GraphQLCurrency.CurrencyAll]: Currency.ALL,
  [GraphQLCurrency.CurrencyAmd]: Currency.AMD,
  [GraphQLCurrency.CurrencyAng]: Currency.ANG,
  [GraphQLCurrency.CurrencyAwg]: Currency.AWG,
  [GraphQLCurrency.CurrencyAzn]: Currency.AZN,
  [GraphQLCurrency.CurrencyBam]: Currency.BAM,
  [GraphQLCurrency.CurrencyBbd]: Currency.BBD,
  [GraphQLCurrency.CurrencyBdt]: Currency.BDT,
  [GraphQLCurrency.CurrencyBgn]: Currency.BGN,
  [GraphQLCurrency.CurrencyBif]: Currency.BIF,
  [GraphQLCurrency.CurrencyBmd]: Currency.BMD,
  [GraphQLCurrency.CurrencyBnd]: Currency.BND,
  [GraphQLCurrency.CurrencyBsd]: Currency.BSD,
  [GraphQLCurrency.CurrencyBwp]: Currency.BWP,
  [GraphQLCurrency.CurrencyByn]: Currency.BYN,
  [GraphQLCurrency.CurrencyBzd]: Currency.BZD,
  [GraphQLCurrency.CurrencyCdf]: Currency.CDF,
  [GraphQLCurrency.CurrencyChf]: Currency.CHF,
  [GraphQLCurrency.CurrencyCny]: Currency.CNY,
  [GraphQLCurrency.CurrencyCzk]: Currency.CZK,
  [GraphQLCurrency.CurrencyDkk]: Currency.DKK,
  [GraphQLCurrency.CurrencyDop]: Currency.DOP,
  [GraphQLCurrency.CurrencyDzd]: Currency.DZD,
  [GraphQLCurrency.CurrencyEgp]: Currency.EGP,
  [GraphQLCurrency.CurrencyEtb]: Currency.ETB,
  [GraphQLCurrency.CurrencyFjd]: Currency.FJD,
  [GraphQLCurrency.CurrencyGel]: Currency.GEL,
  [GraphQLCurrency.CurrencyGip]: Currency.GIP,
  [GraphQLCurrency.CurrencyGmd]: Currency.GMD,
  [GraphQLCurrency.CurrencyGyd]: Currency.GYD,
  [GraphQLCurrency.CurrencyHtg]: Currency.HTG,
  [GraphQLCurrency.CurrencyIdr]: Currency.IDR,
  [GraphQLCurrency.CurrencyIls]: Currency.ILS,
  [GraphQLCurrency.CurrencyIsk]: Currency.ISK,
  [GraphQLCurrency.CurrencyJmd]: Currency.JMD,
  [GraphQLCurrency.CurrencyJpy]: Currency.JPY,
  [GraphQLCurrency.CurrencyKes]: Currency.KES,
  [GraphQLCurrency.CurrencyKgs]: Currency.KGS,
  [GraphQLCurrency.CurrencyKhr]: Currency.KHR,
  [GraphQLCurrency.CurrencyKmf]: Currency.KMF,
  [GraphQLCurrency.CurrencyKrw]: Currency.KRW,
  [GraphQLCurrency.CurrencyKyd]: Currency.KYD,
  [GraphQLCurrency.CurrencyKzt]: Currency.KZT,
  [GraphQLCurrency.CurrencyLbp]: Currency.LBP,
  [GraphQLCurrency.CurrencyLkr]: Currency.LKR,
  [GraphQLCurrency.CurrencyLrd]: Currency.LRD,
  [GraphQLCurrency.CurrencyLsl]: Currency.LSL,
  [GraphQLCurrency.CurrencyMad]: Currency.MAD,
  [GraphQLCurrency.CurrencyMdl]: Currency.MDL,
  [GraphQLCurrency.CurrencyMga]: Currency.MGA,
  [GraphQLCurrency.CurrencyMkd]: Currency.MKD,
  [GraphQLCurrency.CurrencyMmk]: Currency.MMK,
  [GraphQLCurrency.CurrencyMnt]: Currency.MNT,
  [GraphQLCurrency.CurrencyMop]: Currency.MOP,
  [GraphQLCurrency.CurrencyMvr]: Currency.MVR,
  [GraphQLCurrency.CurrencyMwk]: Currency.MWK,
  [GraphQLCurrency.CurrencyMxn]: Currency.MXN,
  [GraphQLCurrency.CurrencyMyr]: Currency.MYR,
  [GraphQLCurrency.CurrencyMzn]: Currency.MZN,
  [GraphQLCurrency.CurrencyNad]: Currency.NAD,
  [GraphQLCurrency.CurrencyNgn]: Currency.NGN,
  [GraphQLCurrency.CurrencyNok]: Currency.NOK,
  [GraphQLCurrency.CurrencyNpr]: Currency.NPR,
  [GraphQLCurrency.CurrencyNzd]: Currency.NZD,
  [GraphQLCurrency.CurrencyPgk]: Currency.PGK,
  [GraphQLCurrency.CurrencyPhp]: Currency.PHP,
  [GraphQLCurrency.CurrencyPkr]: Currency.PKR,
  [GraphQLCurrency.CurrencyPln]: Currency.PLN,
  [GraphQLCurrency.CurrencyQar]: Currency.QAR,
  [GraphQLCurrency.CurrencyRon]: Currency.RON,
  [GraphQLCurrency.CurrencyRsd]: Currency.RSD,
  [GraphQLCurrency.CurrencyRub]: Currency.RUB,
  [GraphQLCurrency.CurrencyRwf]: Currency.RWF,
  [GraphQLCurrency.CurrencySar]: Currency.SAR,
  [GraphQLCurrency.CurrencySbd]: Currency.SBD,
  [GraphQLCurrency.CurrencyScr]: Currency.SCR,
  [GraphQLCurrency.CurrencySek]: Currency.SEK,
  [GraphQLCurrency.CurrencySle]: Currency.SLE,
  [GraphQLCurrency.CurrencySos]: Currency.SOS,
  [GraphQLCurrency.CurrencySzl]: Currency.SZL,
  [GraphQLCurrency.CurrencyTjs]: Currency.TJS,
  [GraphQLCurrency.CurrencyTop]: Currency.TOP,
  [GraphQLCurrency.CurrencyTry]: Currency.TRY,
  [GraphQLCurrency.CurrencyTtd]: Currency.TTD,
  [GraphQLCurrency.CurrencyTwd]: Currency.TWD,
  [GraphQLCurrency.CurrencyTzs]: Currency.TZS,
  [GraphQLCurrency.CurrencyUah]: Currency.UAH,
  [GraphQLCurrency.CurrencyUgx]: Currency.UGX,
  [GraphQLCurrency.CurrencyUzs]: Currency.UZS,
  [GraphQLCurrency.CurrencyVnd]: Currency.VND,
  [GraphQLCurrency.CurrencyVuv]: Currency.VUV,
  [GraphQLCurrency.CurrencyWst]: Currency.WST,
  [GraphQLCurrency.CurrencyXaf]: Currency.XAF,
  [GraphQLCurrency.CurrencyXcd]: Currency.XCD,
  [GraphQLCurrency.CurrencyXcg]: Currency.XCG,
  [GraphQLCurrency.CurrencyYer]: Currency.YER,
  [GraphQLCurrency.CurrencyZar]: Currency.ZAR,
  [GraphQLCurrency.CurrencyZmw]: Currency.ZMW,
};

// Mapping from GraphQL enum string values to domain Currency
const GRAPHQL_STRING_TO_DOMAIN: Record<string, Currency> = {
  CURRENCY_UNKNOWN: Currency.UNKNOWN,
  CURRENCY_USD: Currency.USD,
  CURRENCY_CAD: Currency.CAD,
  CURRENCY_AUD: Currency.AUD,
  CURRENCY_EUR: Currency.EUR,
  CURRENCY_GBP: Currency.GBP,
  CURRENCY_HKD: Currency.HKD,
  CURRENCY_HUF: Currency.HUF,
  CURRENCY_BRL: Currency.BRL,
  CURRENCY_SGD: Currency.SGD,
  CURRENCY_INR: Currency.INR,
  CURRENCY_THB: Currency.THB,
  CURRENCY_AED: Currency.AED,
  CURRENCY_ALL: Currency.ALL,
  CURRENCY_AMD: Currency.AMD,
  CURRENCY_ANG: Currency.ANG,
  CURRENCY_AWG: Currency.AWG,
  CURRENCY_AZN: Currency.AZN,
  CURRENCY_BAM: Currency.BAM,
  CURRENCY_BBD: Currency.BBD,
  CURRENCY_BDT: Currency.BDT,
  CURRENCY_BGN: Currency.BGN,
  CURRENCY_BIF: Currency.BIF,
  CURRENCY_BMD: Currency.BMD,
  CURRENCY_BND: Currency.BND,
  CURRENCY_BSD: Currency.BSD,
  CURRENCY_BWP: Currency.BWP,
  CURRENCY_BYN: Currency.BYN,
  CURRENCY_BZD: Currency.BZD,
  CURRENCY_CDF: Currency.CDF,
  CURRENCY_CHF: Currency.CHF,
  CURRENCY_CNY: Currency.CNY,
  CURRENCY_CZK: Currency.CZK,
  CURRENCY_DKK: Currency.DKK,
  CURRENCY_DOP: Currency.DOP,
  CURRENCY_DZD: Currency.DZD,
  CURRENCY_EGP: Currency.EGP,
  CURRENCY_ETB: Currency.ETB,
  CURRENCY_FJD: Currency.FJD,
  CURRENCY_GEL: Currency.GEL,
  CURRENCY_GIP: Currency.GIP,
  CURRENCY_GMD: Currency.GMD,
  CURRENCY_GYD: Currency.GYD,
  CURRENCY_HTG: Currency.HTG,
  CURRENCY_IDR: Currency.IDR,
  CURRENCY_ILS: Currency.ILS,
  CURRENCY_ISK: Currency.ISK,
  CURRENCY_JMD: Currency.JMD,
  CURRENCY_JPY: Currency.JPY,
  CURRENCY_KES: Currency.KES,
  CURRENCY_KGS: Currency.KGS,
  CURRENCY_KHR: Currency.KHR,
  CURRENCY_KMF: Currency.KMF,
  CURRENCY_KRW: Currency.KRW,
  CURRENCY_KYD: Currency.KYD,
  CURRENCY_KZT: Currency.KZT,
  CURRENCY_LBP: Currency.LBP,
  CURRENCY_LKR: Currency.LKR,
  CURRENCY_LRD: Currency.LRD,
  CURRENCY_LSL: Currency.LSL,
  CURRENCY_MAD: Currency.MAD,
  CURRENCY_MDL: Currency.MDL,
  CURRENCY_MGA: Currency.MGA,
  CURRENCY_MKD: Currency.MKD,
  CURRENCY_MMK: Currency.MMK,
  CURRENCY_MNT: Currency.MNT,
  CURRENCY_MOP: Currency.MOP,
  CURRENCY_MVR: Currency.MVR,
  CURRENCY_MWK: Currency.MWK,
  CURRENCY_MXN: Currency.MXN,
  CURRENCY_MYR: Currency.MYR,
  CURRENCY_MZN: Currency.MZN,
  CURRENCY_NAD: Currency.NAD,
  CURRENCY_NGN: Currency.NGN,
  CURRENCY_NOK: Currency.NOK,
  CURRENCY_NPR: Currency.NPR,
  CURRENCY_NZD: Currency.NZD,
  CURRENCY_PGK: Currency.PGK,
  CURRENCY_PHP: Currency.PHP,
  CURRENCY_PKR: Currency.PKR,
  CURRENCY_PLN: Currency.PLN,
  CURRENCY_QAR: Currency.QAR,
  CURRENCY_RON: Currency.RON,
  CURRENCY_RSD: Currency.RSD,
  CURRENCY_RUB: Currency.RUB,
  CURRENCY_RWF: Currency.RWF,
  CURRENCY_SAR: Currency.SAR,
  CURRENCY_SBD: Currency.SBD,
  CURRENCY_SCR: Currency.SCR,
  CURRENCY_SEK: Currency.SEK,
  CURRENCY_SLE: Currency.SLE,
  CURRENCY_SOS: Currency.SOS,
  CURRENCY_SZL: Currency.SZL,
  CURRENCY_TJS: Currency.TJS,
  CURRENCY_TOP: Currency.TOP,
  CURRENCY_TRY: Currency.TRY,
  CURRENCY_TTD: Currency.TTD,
  CURRENCY_TWD: Currency.TWD,
  CURRENCY_TZS: Currency.TZS,
  CURRENCY_UAH: Currency.UAH,
  CURRENCY_UGX: Currency.UGX,
  CURRENCY_UZS: Currency.UZS,
  CURRENCY_VND: Currency.VND,
  CURRENCY_VUV: Currency.VUV,
  CURRENCY_WST: Currency.WST,
  CURRENCY_XAF: Currency.XAF,
  CURRENCY_XCD: Currency.XCD,
  CURRENCY_XCG: Currency.XCG,
  CURRENCY_YER: Currency.YER,
  CURRENCY_ZAR: Currency.ZAR,
  CURRENCY_ZMW: Currency.ZMW,
};

// Set of valid GraphQL currency string values for efficient lookup
const GRAPHQL_CURRENCY_STRINGS = new Set<string>(
  Object.keys(GRAPHQL_STRING_TO_DOMAIN)
);

/**
 * Type guard to check if a value is a domain Currency enum.
 * Currency enum values are strings like 'USD', 'CAD', etc.
 */
export function isCurrency(value: unknown): value is Currency {
  if (typeof value !== 'string') {
    return false;
  }

  const currencyValues: string[] = Object.values(Currency);

  return currencyValues.includes(value);
}

/**
 * Type guard to check if a value is a GraphQLCurrency enum.
 * GraphQLCurrency is a string enum, so values are strings like 'CURRENCY_USD', 'CURRENCY_CAD', etc.
 */
export function isGraphQLCurrencyEnum(
  value: unknown
): value is GraphQLCurrency {
  if (typeof value !== 'string') {
    return false;
  }

  // Check if the string value exists as an own property key in GRAPHQL_TO_DOMAIN
  // GraphQLCurrency enum values are strings that map to domain Currency
  // Use Object.hasOwn() to avoid checking prototype chain (e.g., 'toString', 'constructor')
  return Object.hasOwn(GRAPHQL_TO_DOMAIN, value);
}

/**
 * Type guard to check if a string is a GraphQL currency string.
 * GraphQL currency strings are like 'CURRENCY_USD', 'CURRENCY_CAD', etc.
 */
export function isGraphQLCurrencyString(value: unknown): value is string {
  return typeof value === 'string' && GRAPHQL_CURRENCY_STRINGS.has(value);
}

/**
 * Convert domain Currency to GraphQL Currency enum.
 * Maps from our domain enum (CURRENCY_USD) to GraphQL enum keys (CurrencyUsd).
 */
export function currencyToGraphQL(currency: Currency): GraphQLCurrency {
  return DOMAIN_TO_GRAPHQL[currency] ?? GraphQLCurrency.CurrencyUnknown;
}

/**
 * Convert GraphQL Currency enum to domain Currency.
 * GraphQLCurrency is a string enum, so values are strings like 'CURRENCY_USD', 'CURRENCY_CAD', etc.
 * Also handles ISO currency codes (e.g., 'USD', 'CAD') as a fallback.
 */
export function graphQLToCurrency(
  gqlCurrency: GraphQLCurrency | string | undefined | null
): Currency {
  if (!gqlCurrency) {
    return Currency.UNKNOWN;
  }

  // GraphQLCurrency is a string enum, so all values are strings
  if (typeof gqlCurrency !== 'string') {
    return Currency.UNKNOWN;
  }

  // Try GraphQL enum string values (CURRENCY_USD, CURRENCY_CAD, etc.)
  const fromString = GRAPHQL_STRING_TO_DOMAIN[gqlCurrency];

  if (fromString !== undefined) {
    return fromString;
  }

  // Try parsing as currency code (USD, CAD, etc.)
  return parseCurrency(gqlCurrency);
}

/**
 * Map from Currency enum to SupportedPaymentCurrency.
 * Returns USD as default for unknown or unsupported currencies.
 *
 * @param currency - Domain Currency enum, GraphQL Currency enum, or GraphQL currency string (e.g., 'CURRENCY_USD')
 *                    Accepts GraphQL values as a stopgap for client correctness.
 */
function convertToDomainCurrency(
  currency: Currency | GraphQLCurrency | string
): Currency {
  if (isCurrency(currency)) {
    // Already a domain Currency enum, use directly
    return currency;
  }

  if (isGraphQLCurrencyEnum(currency)) {
    // GraphQLCurrency enum object, convert via mapping
    return GRAPHQL_TO_DOMAIN[currency] ?? Currency.UNKNOWN;
  }

  if (isGraphQLCurrencyString(currency)) {
    // GraphQL currency string (e.g., 'CURRENCY_USD'), convert via mapping
    return GRAPHQL_STRING_TO_DOMAIN[currency] ?? Currency.UNKNOWN;
  }

  // Fallback: try parsing as ISO currency code (e.g., 'USD', 'CAD')
  return parseCurrency(currency);
}

/**
 * Map from Currency enum to SupportedPaymentCurrency.
 * Returns USD as default for unknown or unsupported currencies.
 *
 * This function handles GraphQL types and delegates to the domain function for the core logic.
 * For backwards compatibility with potentially invalid GraphQL data, this function catches
 * errors from the domain function and falls back to USD. For server-side code that only needs
 * to handle Currency, use `currencyToPaymentCurrency` from `domains-billing-currency` directly.
 *
 * @param currency - Domain Currency enum, GraphQL Currency enum, or GraphQL currency string (e.g., 'CURRENCY_USD')
 *                    Accepts GraphQL values as a stopgap for client correctness.
 */
export function currencyToPaymentCurrency(
  currency: Currency | GraphQLCurrency | string | undefined
): SupportedPaymentCurrency {
  if (!currency) {
    return Currency.USD;
  }

  try {
    // If already a domain Currency enum, delegate to the domain function
    if (isCurrency(currency)) {
      return domainCurrencyToPaymentCurrency(currency);
    }

    // Convert GraphQL types to domain Currency first
    const domainCurrency = convertToDomainCurrency(currency);

    // Delegate to the domain function for the core logic
    return domainCurrencyToPaymentCurrency(domainCurrency);
  } catch {
    // For backwards compatibility with potentially invalid GraphQL data,
    // catch errors from the strict domain function and fall back to USD

    // This allows the web-mapper to handle messy client data gracefully
    return Currency.USD;
  }
}

/**
 * Map from legacy currency string codes to Currency enum.
 * Handles string currency codes (e.g., 'USD', 'CAD') and converts them to Currency enum.
 * Note: EssensysCredits is not a supported currency in our domain.
 */
export function paymentCurrencyToCurrency(
  paymentCurrency: string | undefined
): Currency {
  if (!paymentCurrency) {
    return Currency.UNKNOWN;
  }

  // Parse using the domain parseCurrency function
  return parseCurrency(paymentCurrency);
}

/**
 * Legacy converter that handles mixed types (GraphQL enums, numeric, or string codes).
 * This replaces the old convertCurrencyEnum function.
 *
 * @deprecated Use specific mappers (graphQLToCurrency, parseCurrency) instead.
 */
export function convertCurrencyEnum(
  currencyEnum: unknown,
  defaultValue?: Currency
): Currency {
  if (!currencyEnum) {
    return defaultValue ?? Currency.UNKNOWN;
  }

  // Handle numeric values (from protobuf) - shouldn't happen in web context
  if (typeof currencyEnum === 'number') {
    console.warn(
      'convertCurrencyEnum received numeric value in web context, this may indicate incorrect usage'
    );

    return defaultValue ?? Currency.UNKNOWN;
  }

  // Handle string values (GraphQL enums or currency codes)
  if (typeof currencyEnum === 'string') {
    // Try GraphQL conversion first
    const fromGql = graphQLToCurrency(currencyEnum);

    if (fromGql !== Currency.UNKNOWN) {
      return fromGql;
    }
  }

  return defaultValue ?? Currency.UNKNOWN;
}
